// Text-colour and highlight swatches offered by RichTextEditor's colour pickers.
// `className` is the CSS class written into the saved HTML (see .rte-text-*
// and .rte-hl-* rules in App.css and the matching `.article-body` rules used
// to render the saved content on the public blog page) — `swatch` is only
// used to paint the picker button itself.

export const TEXT_COLORS = [
  { className: 'rte-text-slate', label: 'Slate', swatch: '#334155' },
  { className: 'rte-text-indigo', label: 'Indigo', swatch: '#4f46e5' },
  { className: 'rte-text-teal', label: 'Teal', swatch: '#0f766e' },
  { className: 'rte-text-red', label: 'Red', swatch: '#dc2626' },
  { className: 'rte-text-amber', label: 'Amber', swatch: '#d97706' },
  { className: 'rte-text-green', label: 'Green', swatch: '#16a34a' },
];

export const HIGHLIGHTS = [
  { className: 'rte-hl-yellow', label: 'Yellow', swatch: '#fef08a' },
  { className: 'rte-hl-green', label: 'Green', swatch: '#bbf7d0' },
  { className: 'rte-hl-blue', label: 'Blue', swatch: '#bfdbfe' },
  { className: 'rte-hl-pink', label: 'Pink', swatch: '#fbcfe8' },
];
